import { borderRadius, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const CardWrapper = styled.div`
  padding: 12px;
  background-color: var(--surface-default);
  border: 1px solid var(--border-soft);
  ${borderRadius.r2};
  display: flex;
  justify-content: space-between;
  gap: 8px;
`;

export const Favicon = styled.img`
  width: 24px;
  height: 24px;
  ${borderRadius.rFull};
`;

export const Content = styled.div<{ $onlyUrl?: boolean }>`
  display: flex;
  align-items: ${props => (props.$onlyUrl ? 'center' : 'flex-start')};
  gap: 12px;
  flex: 1;
  min-width: 0;
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;

export const Title = styled.span`
  ${typographyV2.bodyBase};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Url = styled.span`
  ${typographyV2.bodySm};
  color: var(--text-soft);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
